export const MCP_SERVER_URL = 'https://mcp.apps.faradaysec.com/mcp';

export const MCP_SERVER_TIMEOUT = 5000;
